import React, { useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import Modal from '../../../../shared/modal';
import Input from '../../../../shared/input';
import Button from '../../../../shared/button';
import Error from '../../../../shared/error';
import { tryToInviteNewMember } from '../../../../store/brokers/partners/demo-requests/requestsSlice';
import SelectCheckbox from '../../../../shared/select-checkbox';
import { CHARLES_DASHBOARD, LEO_DASHBOARD, REBECCA_DASHBOARD, SOFIA_DASHBOARD } from '../../../../config';

const AIAgents = [
    { label: 'Leo - AI Search', value: 'leo', dashboard: `${LEO_DASHBOARD}`, emailText: 'Leo, the AI Search Engine Agent' },
    { label: 'Charles - AI Account Manager', value: 'charles', dashboard: `${CHARLES_DASHBOARD}`, emailText: 'Charles, the AI Account Manager Agent' },
    { label: 'Rebecca - AI Guest Experience', value: 'rebecca', dashboard: `${REBECCA_DASHBOARD}`, emailText: 'Rebecca, the AI Guest Experience Manager Agent' },
    { label: 'Sofia - AI Employee Search Assistant', value: 'sofia', dashboard: `${SOFIA_DASHBOARD}`, emailText: 'Sofia, the AI Employee Search Assistant Agent' },
]

const businessTypes = [
    { label: 'Hotel', value: 'HOTEL' },
    { label: 'Restaurant', value: 'RESTAURANT' },
]

interface IInviteModal {
    openModal: boolean;
    handleCloseModal: () => void;
    onSaveChanges: (type: string, message: string) => void;
}

const InviteModal = ({
    openModal,
    handleCloseModal,
    onSaveChanges,
}: IInviteModal) => {
    const dispatch = useAppDispatch();

    const [form, setForm] = useState({
        email: '',
        name: '',
        companyName: '',
        address: '',
        businessType: '',
        worker: ''
    });

    const [submitError, setSubmitError] = useState<string>();

    const onCloseModal = () => {
        setForm({ email: '', name: '', companyName: '', address: '', worker: '', businessType: '' });
        setSubmitError(undefined);
        handleCloseModal();
    };

    const onChange = (value: any, field?: string) => {
        if (field) {
            setForm(prev => ({ ...prev, [field]: value }));
        }
    };

    const allFieldsFilled = Object.values(form).every(v => v.trim().length > 0);

    const onSubmitInvite = async () => {
        if (!allFieldsFilled) {
            setSubmitError('All fields are required.');
            return;
        }

        try {
            setSubmitError(undefined)
            const agent = AIAgents?.find((item: any) => item?.value === form?.worker)
            await dispatch(
                tryToInviteNewMember({
                    ...form,
                    link: agent?.dashboard,
                    text: agent?.emailText,
                    source: 'AM_DASHBOARD'
                })
            ).unwrap();

            onSaveChanges('success', 'Invite sent successfully');
            onCloseModal();
        } catch (err: any) {
            setSubmitError(err?.data?.message || err?.message || err?.response?.message || String(err));
        }
    };

    const onChangeSelectedWorker = (value: any) => {
        setForm(prev => ({ ...prev, worker: value?.value }));
    }

    const onChangeSelectedType = (value: any) => {
        setForm(prev => ({ ...prev, businessType: value?.value }));
    }

    return (
        <Modal
            open={openModal}
            onClose={onCloseModal}
            contentContainerStyle={'!rounded-xl min-w-[95%] md:min-w-[70%] lg:min-w-[450px]'}
        >
            <div className='p-2 max-w-[98vw] min-w-[95%] md:min-w-[70%] lg:w-[400px]'>
                <div className='flex flex-row justify-between items-center'>
                    <p className='mb-2 font-semibold text-sm dark:text-primary-dark'>
                        Leo AI Search Engine Agent - New Invite
                    </p>
                </div>

                <div className='my-3'>
                    <p className='dark:text-primary-dark mb-4'>Provide information for the new invite</p>

                    {submitError && <Error text={submitError} />}

                    <Input
                        label='Name'
                        showValue={true}
                        inputValue={form?.name}
                        inputUniqueName='name'
                        onChangeInput={onChange}
                    />
                    <Input
                        label='Email'
                        showValue={true}
                        inputValue={form.email}
                        inputUniqueName='email'
                        onChangeInput={onChange}
                    />
                    <Input
                        label='Company Name'
                        showValue={true}
                        inputValue={form.companyName}
                        inputUniqueName='companyName'
                        onChangeInput={onChange}
                    />
                    <Input
                        label='Company Address'
                        showValue={true}
                        inputValue={form.address}
                        inputUniqueName='address'
                        onChangeInput={onChange}
                    />
                    <SelectCheckbox
                        name='Business Type'
                        selectedOption={form.businessType ? businessTypes?.find((item: any) => item?.value === form?.businessType) : undefined}
                        options={businessTypes}
                        uniqueName='type'
                        onChangeSelectedOption={onChangeSelectedType}
                    />
                    <SelectCheckbox
                        name='AI Workers'
                        selectedOption={form?.worker ? AIAgents?.find((item: any) => item?.value === form?.worker) : undefined}
                        options={AIAgents}
                        onChangeSelectedOption={onChangeSelectedWorker}
                    />
                </div>

                <div className='flex flex-row justify-center'>
                    <Button
                        label={'Submit Invite'}
                        className={`${allFieldsFilled ? 'btn-primary-rounded-less' : 'btn-primary-rounded-less-disable'}`}
                        onClickButton={onSubmitInvite}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default InviteModal;
